@let warnings = accountWarnings | select:[];
@if (warnings.length > 0) {
  <div class="flex flex-row gap-3 w-full max-w-[60rem] justify-center pl-3 pr-3 md:pr-0 md:pl-6 lg:pl-10 py-3 md:py-[0.375rem]">
    <!-- Warning Icon -->
    <mat-icon class="mat-icon-size-5.5 shrink-0 mt-2">error_outline</mat-icon>

    <!-- Warning Messages -->
    <div class="flex flex-col w-full pt-[0.125rem] gap-3 lg:gap-0">
      @for (warning of warnings; track $index) {
        <ng-container *ngTemplateOutlet="warningMessage; context: {warning: warning}"/>
      }
    </div>
  </div>
}

<ng-template #warningMessage let-warning="warning">
  <div class="flex flex-col md:flex-row md:justify-between md:gap-4 md:items-center min-h-9">
    <!-- Warning Message -->
    <div class="w-full text-body-large">
      {{ warning.message }}
    </div>

    <!-- Warning Action -->
    <div class="md:w-[10rem] shrink-0 self-end md:self-center">
      @if (warning.actionRoute) {
        <mx-text-button [label]="warning.actionLabel" [routeName]="warning.actionRoute"/>
      }
    </div>
  </div>
</ng-template>
